<div class="container-fluid p-3 bg-amber-50">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <hr class="my-3" />

  <div class="mb-4"  *ngIf="(schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII') 
  && stepDetails?.code !== 'E-RDPR'" class="form-container">
      <!-- <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
        <p class="p-2 bg-primary text-white ">{{stepDetails.name}}</p>
        <editor [init]="init" formControlName="pre_bid" [disabled]="isEditorDisabled"></editor>
      </div> -->

      <div class="editor-field mt-4">
        <p class="bg-blue-500 p-2 text-white font-medium">Questionnaire</p>
        <!-- <editor [init]="questionnaireData" [formControlName]="'sqr_content'" ></editor> -->
        <editor 
        *ngIf="questionnaireContent"
      [init]="questionnaireData" 
      [(ngModel)]="questionnaireContent">
    </editor>
      </div>

    </div>
    <hr class="my-3" />

  <!-- Vendor Selection Section -->
  <div  class="mb-6 mx-2">
    <div class="bg-white rounded shadow-md p-4 border border-blue-200" *ngIf="format == 'upload' &&stepDetails?.can_edit">
      <h2 class="text-lg font-bold text-blue-900 mb-4 flex items-center gap-2">
        <i class="pi pi-cloud-upload text-blue-600 text-xl"></i>
        Upload Vendor Files & Select from Master List
        <button *ngIf="files.file1 && files.file2"
          class="inline-flex items-center gap-2 ml-4 px-3 py-1 text-sm font-semibold rounded shadow-md border-2 border-purple-500 bg-purple-100 text-purple-700 hover:bg-purple-500  hover:text-white  transition "
          (click)="submitFiles()"> <i class="pi pi-check-circle mr-2"></i> Submit</button>
      </h2>
      <form *ngIf="isVisibleResponseUpload" [formGroup]="agencieForm" class="w-full">
        <div class="flex flex-col gap-4">
          <!-- Row 1: File Uploads (CSV and ZIP) -->
          <div class="flex flex-col md:flex-row gap-4 w-full">
            <!-- CSV File Upload -->
            <div
              class="flex-1 flex flex-col bg-amber-50 rounded-md border border-dashed border-amber-300 p-4 transition hover:shadow hover:bg-amber-100">
              <label for="fileUpload1" class="block font-semibold text-amber-900 mb-2">
                <i class="pi pi-file-excel text-green-600 mr-2"></i>
                Upload Vendor Info (.csv) <span class="text-red-500">*</span>
              </label>
              <input type="file" id="fileUpload1" accept=".csv,.xlsx,.xls"
                class="border-2 border-green-200 px-4 py-2 rounded shadow-sm transition focus:ring focus:ring-green-200"
                (change)="handleFileInput($event, 'file1')" />
            </div>
            <!-- ZIP File Upload -->
            <div
              class="flex-1 flex flex-col bg-blue-50 rounded-md border border-dashed border-blue-300 p-4 transition hover:shadow hover:bg-blue-100">
              <label for="fileUpload2" class="block font-semibold text-blue-900 mb-2">
                <i class="pi pi-folder-open text-blue-600 mr-2"></i>
                Upload Briefcase Folder (.zip) <span class="text-red-500">*</span>
              </label>
              <input type="file" id="fileUpload2" accept=".zip"
                class="border-2 border-blue-200 px-4 py-2 rounded shadow-sm transition focus:ring focus:ring-blue-200"
                (change)="handleFileInput($event, 'file2')" />
            </div>
          </div>
          <!-- Row 2: Partner Incubators -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
            <div class="flex flex-col">
              <label for="agencie_1" class="block font-medium text-slate-700 mb-2">
                Partner Incubator 1
                <ng-container
                  *ngIf="agencieForm.get('agencie_1')?.errors?.['required'] || agencieForm.get('agencie_1')?.hasValidator(requiredValidator)">
                  <span class="text-red-500">*</span>
                </ng-container>
              </label>
              <input pInputText id="agencie_1" formControlName="agencie_1" autocomplete="off"
                class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
            </div>
            <div class="flex flex-col">
              <label for="agencie_2" class="block font-medium text-slate-700 mb-2">
                Partner Incubator 2
                <ng-container
                  *ngIf="agencieForm.get('agencie_2')?.errors?.['required'] || agencieForm.get('agencie_2')?.hasValidator(requiredValidator)">
                  <span class="text-red-500">*</span>
                </ng-container>
              </label>
              <input pInputText id="agencie_2" formControlName="agencie_2" autocomplete="off"
                class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
            </div>
            <div class="flex flex-col">
              <label for="agencie_3" class="block font-medium text-slate-700 mb-2">
                Partner Incubator 3
                <ng-container
                  *ngIf="agencieForm.get('agencie_3')?.errors?.['required'] || agencieForm.get('agencie_3')?.hasValidator(requiredValidator)">
                  <span class="text-red-500">*</span>
                </ng-container>
              </label>
              <input pInputText id="agencie_3" formControlName="agencie_3" autocomplete="off"
                class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
            </div>
          </div>
        </div>
      </form>

      <!-- Master Vendor Box -->
      <div *ngIf="!isVisibleResponseUpload"
        class="col-span-2 flex flex-col bg-slate-50 rounded border border-slate-200 p-3 shadow transition hover:bg-slate-100">
        <label for="vendorMasterDropdown" class="font-semibold text-slate-700 mb-3 flex items-center">
          <i class="pi pi-user-plus mr-2 text-indigo-700"></i>
          Select Vendor from Master List
        </label>
        <p-multiSelect [options]="masterVendorList" [(ngModel)]="selectedMasterVendor" optionLabel="name"
          [filter]="true" optionValue="id" filterBy="name" placeholder="Select Vendor(s)" display="chip"
          [showToggleAll]="true" [showClear]="true" [maxSelectedLabels]="3" defaultLabel="Select Vendor(s)"
          styleClass="w-full mb-3"></p-multiSelect>
        <div class="flex gap-2 mt-2">
          <button [disabled]="!selectedMasterVendor?.length" type="button" id="vendorMasterDropdown"
            class="inline-flex items-center px-5 py-2 bg-emerald-600 text-white rounded shadow hover:bg-emerald-700 transition disabled:bg-slate-300 disabled:cursor-not-allowed"
            (click)="addVendorFromMaster()">
            <i class="pi pi-plus-circle mr-2"></i>
            Add Selected
          </button>
          <button
            class="inline-flex items-center px-5 py-2 bg-yellow-500 text-white rounded shadow hover:bg-yellow-600 transition"
            (click)="openAdd()" type="button">
            <i class="pi pi-user-edit mr-2"></i>
            Add New Vendor
          </button>
        </div>
      </div>

    </div>

     
  

  <div *ngIf="format == 'pds-pru-evaluation' && schemeType === 'idex'" class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
    <ng-container *ngIf="schemeType == 'idex' && stepDetails?.step_mapping?.scheme?.id == 7" >
      <app-idex-from  *ngIf="challengesData" [stepDetails]="stepDetails"  [url]="'/idex/upload/compliance/pds-pru/'"  [challengesData]="challengesData"
        [categoryFormVisible]="getValuationFieldVisible(stepDetails)"
      ></app-idex-from>
    </ng-container>
   <ng-container *ngIf="schemeType == 'idex' && stepDetails?.step_mapping?.scheme?.id !== 7">

 <div (click)="expandedSections['documentUploads'] = !expandedSections['documentUploads']"
        class="flex items-center justify-between p-2.5 cursor-pointer bg-blue-950 text-white transition-all duration-200">
        <h3 class="text-lg font-semibold  flex items-center">
            <span
                class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-paperclip"></i>
            </span>
            Download PDS and PRU  
        </h3>
        <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['documentUploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
    </div>
    </ng-container>  
     

    <div *ngIf="expandedSections['documentUploads']" class="p-1 space-y-4 border-t border-slate-100 animate-fade-in">

      <app-upload-document [isEditable]="false" [proposal_step]="fristStepData"> </app-upload-document>
    </div>
  </div>




  <!-- Document Upload Section -->
  <div *ngIf="!isVisibleResponseUpload" class="mb-10 mt-8 transition-all duration-200 hover:shadow-md">
    <div class="">
      <div class="">
        <div>
          <div class="divide-y divide-gray-200">

            <ng-container *ngFor="let row of winners; let i = index">
              <div>
                <!-- Header -->
                <div
                  class="flex items-center justify-between p-4 my-3 cursor-pointer bg-gray-300/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
                  (click)="row.isSectionOpen = !row.isSectionOpen">
                  <div class="flex items-center">
                    <!-- First letter of vendor name -->
                    <span
                      class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-base font-bold">
                      {{ row.company_name?.charAt(0) || row.vendor.company_name?.charAt(0) || '-' }}
                    </span>

                    <!-- Vendor name -->
                    <span class="font-semibold text-lg">
                      {{ row.company_name || row.vendor.company_name || '-' }}
                    </span>

                    <!-- Status chip -->
                    <span *ngIf="row.vendor_status" class="ml-3 px-2 py-1 text-sm font-medium border-2 rounded-lg"
                      [ngClass]="{
                        'border-green-600 text-green-600 bg-green-100': row.vendor_status === 'Qualify',
                        'border-red-600 text-red-600 bg-red-100': row.vendor_status === 'Disqualify'
                      }">
                      {{ getLable(row.vendor_status) }}
                    </span>
                  </div>

                  <!-- Qualify / Disqualify buttons -->
                  <div class="flex gap-2"
                    *ngIf="!row.vendor_status && ['pds-pru-evaluation', 'evaluation', 'screening'].includes(format)">
                    <button [disabled]="!stepDetails.can_edit"
                      class="px-3 py-1 text-sm font-semibold rounded border border-green-600 text-green-600 bg-green-100 hover:bg-green-50 transition disabled:opacity-50"
                      (click)="setStatus(row, 'Qualify'); $event.stopPropagation()">
                      <i class="pi pi-check-circle mr-2"></i> {{ getLable('Qualify')}}
                    </button>

                    <button [disabled]="!stepDetails.can_edit"
                      class="px-3 py-1 text-sm font-semibold rounded border border-red-600 bg-red-100 text-red-600 hover:bg-red-50 transition disabled:opacity-50"
                      (click)="setStatus(row, 'Disqualify'); $event.stopPropagation()">
                      <i class="pi pi-times-circle mr-2"></i> {{ getLable('Disqualify')}}
                    </button>
                  </div>

                  <i class="pi transition-transform duration-200"
                    [ngClass]="row.isSectionOpen ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                </div>

                <!-- Details section -->
                <div *ngIf="row.isSectionOpen" class="p-1 space-y-4 border-t border-slate-100 animate-fade-in">
                  <div class="bg-white rounded-lg shadow-sm p-2 border border-gray-200 mx-auto max-w-7xl">
                    <app-vender-specfic-document [proposalStep]="stepDetails" [vendorId]="row?.vendor?.id || row?.id"
                      [isEdit]="stepDetails?.can_edit && ![ 'evaluation', 'screening'].includes(format)" [url]="url">
                    </app-vender-specfic-document>
                  </div>
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isVisibleResponseUpload"
    class="bg-amber-50 border-2 border-gray-300 mb-6 transition-all duration-200 hover:shadow-md mx-2">
    <div
      class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
      <h3 class="text-lg font-semibold flex items-center">
        <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm"><i
            class="pi pi-paperclip"></i></span>
        Vender Uploaded Response
      </h3>
      <div class="flex gap-2 items-center">
        <button type="button"
          class="border-2 border-blue-400 bg-blue-100 text-blue-700 font-bold px-3 py-1 rounded shadow-none hover:border-blue-600 hover:bg-blue-200"
          title="Nill" (click)="showSampleDialog=true">
          <i class="pi pi-eye-slash mr-1"></i> Hide columns
        </button>

        <button *ngIf=" ['pds-pru-evaluation', 'evaluation', 'screening' ,'upload'].includes(format) "
          type="button" [disabled]="selectedProposals.length === 0"
          [ngClass]="{'opacity-50 cursor-not-allowed': selectedProposals.length === 0}"
          class="border-2 border-green-400 bg-green-100 text-green-700 font-bold px-3 py-1 rounded shadow-none hover:border-green-600 hover:bg-green-200"
          title="Qualify" (click)="openAcceptRejectPopup('Qualify')">
          <i class="pi pi-thumbs-up mr-1"></i>  {{getLable('Qualify')}}
        </button>
        <button *ngIf=" ['pds-pru-evaluation', 'evaluation', 'screening' ,'upload'].includes(format)"
          type="button" [disabled]="selectedProposals.length === 0"
          [ngClass]="{'opacity-50 cursor-not-allowed': selectedProposals.length === 0}"
          class="border-2 border-red-400 bg-red-100 text-red-700 font-bold px-3 py-1 rounded shadow-none hover:border-red-600 hover:bg-red-200"
          title="Disqualify" (click)="openAcceptRejectPopup('Disqualify')">
          <i class="pi pi-times mr-1"></i>  {{getLable('Disqualify')}}
        </button>
      </div>

    </div>
    <div class="p-2 space-y-4 border-t border-slate-100 animate-fade-in">

      <p-table #dt [value]="winners" [paginator]="tableData.length > 10" [rows]="10" [showCurrentPageReport]="true"
        selectionMode="multiple" [scrollable]="true" [(selection)]="selectedProposals" [resizableColumns]="true"
        [reorderableColumns]="true" dataKey="id" class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr>
            <th class="w-10 bg-blue-100 border-b border-blue-200"></th>
            <ng-container *ngFor="let column of filterColoum">
              <th [pSortableColumn]="column.field" pResizableColumn>
                <div class="flex items-center justify-between">
                  <span>{{ column.header }}</span>
                  <i class="fa-solid fa-signal fa-rotate-270 ml-4 text-xs"></i>
                </div>
              </th>
            </ng-container>
            <th pFrozenColumn alignFrozen="right"
              class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">
              Actions
            </th>
            <!-- <th pFrozenColumn class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">Actions</th> -->
          </tr>
          <tr>
            <th></th>
            <th *ngFor="let column of filterColoum">
              <input *ngIf="column.filterType" type="text" [(ngModel)]="column.filterValue"
                (input)="dt.filter(column.filterValue, column.field, 'contains')" [attr.placeholder]=" column.header"
                class="w-full px-2 py-1 border-blue-200 rounded font-medium text-gray-600 text-xs" />
            </th>
            <th pFrozenColumn alignFrozen="right"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-proposal>
          <tr class="hover:bg-blue-50 transition-colors duration-200">
            <td class="align-middle px-2 py-2 border-b border-gray-100">
              <p-tableCheckbox
                [disabled]="proposal.vendor_status === 'Qualify' || proposal.vendor_status === 'Disqualify'"
                [value]="proposal"></p-tableCheckbox>
            </td>
            <ng-container *ngFor="let column of filterColoum">
              <td class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
                <ng-container [ngSwitch]="column.vType">
                  <ng-container *ngSwitchCase="'status'">
                    <span [ngClass]="getStatusClass(proposal[column.field])"
                      class="inline-flex items-center px-3 py-1 rounded-full text-xs border-2 font-bold ">{{
                      proposal[column.field] }}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'dropdown'">
                    <span class="whitespace-pre-wrap min-w-[120px]">{{ proposal[column.field] || '-' }}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'supporting_doc'">
                    <button
                      class="border-2 border-yellow-400 bg-yellow-100 text-yellow-700 font-bold px-2 py-1 rounded shadow-none mr-2 text-base hover:border-yellow-500 hover:bg-yellow-200 transition-colors outline-none focus:outline-none"
                      (click)="downloadProposal(proposal?.briefcase)" title="Download">
                      <i class="pi pi-download"></i>
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <span class="whitespace-pre-wrap min-w-[200px]">{{ proposal[column.field] || '-' }}</span>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
            <td pFrozenColumn alignFrozen="right"
              class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
              <button
                class="border-2 border-purple-400 bg-purple-100 text-purple-700 font-bold px-2 py-1 rounded shadow-none mr-2 text-base hover:border-purple-500 hover:bg-purple-200 transition-colors outline-none focus:outline-none"
                (click)="openPopup(proposal)" title="View">
                <i class="pi pi-eye"></i>
              </button>

              <button *ngIf="role_id ==='19'"
                class="border-2 border-red-400 bg-red-100 text-red-700 font-bold px-2 py-1 rounded shadow-none text-base hover:border-red-500 hover:bg-red-200 transition-colors outline-none focus:outline-none"
                (click)="deleteProposal(proposal)" title="Delete">
                <i class="pi pi-trash"></i>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="tableColumns.length + 2" class="text-center py-8 text-gray-400"><i
                class="pi pi-info-circle mr-2"></i> No proposals found.</td>
          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
  <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'" class="mt-4">
    <app-upload-document [title]="stepDetails.name+'Document'" [isEditable]="stepDetails?.can_edit"> </app-upload-document>

    
  </div>
</div>

<!-- Vendor Details Dialog for Non-IDEX -->
<p-dialog header="Vendor Details" [(visible)]="visible" [modal]="true" [resizable]="true" [maximizable]="true"
  [style]="{ width: '600px' }" appendTo="body">
  <!-- src/app/vendor-form/vendor-form.component.html -->
  <form [formGroup]="commentForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="row g-3 mt-2">

      <!-- Vendor Name -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="vendor" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            Vendor Name <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input id="vendor" type="text" class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('vendor')?.touched && commentForm.get('vendor')?.invalid}"
              formControlName="vendor" autocomplete="off" maxlength="100" />
            <div class="invalid-feedback">Vendor Name is required (max 100 chars).</div>
          </div>
        </div>
      </div>

      <!-- company name -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="name" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            Company Name <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input id="name" type="text" class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('name')?.touched && commentForm.get('name')?.invalid}"
              formControlName="name" autocomplete="off" maxlength="100" />
            <div class="invalid-feedback">Company Name is required (max 100 chars).</div>
          </div>
        </div>
      </div>

      <!-- Contact Person -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="contactPerson" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            Contact Person’s Name <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input id="contactPerson" type="text" class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('contactPerson')?.touched && commentForm.get('contactPerson')?.invalid}"
              formControlName="contactPerson" autocomplete="off" maxlength="100" />
            <div class="invalid-feedback">
              <ng-container *ngIf="commentForm.get('contactPerson')?.hasError('required')">Required.</ng-container>
              <ng-container *ngIf="commentForm.get('contactPerson')?.hasError('pattern')">Only alphabets and spaces
                allowed.</ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Email -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="email" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            Email <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input id="email" type="email" class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('email')?.touched && commentForm.get('email')?.invalid}"
              formControlName="email" autocomplete="off" />
            <div class="invalid-feedback">
              <ng-container *ngIf="commentForm.get('email')?.hasError('required')">Email is required.</ng-container>
              <ng-container *ngIf="commentForm.get('email')?.hasError('email')">Invalid email format.</ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Phone -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="phone" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            Phone Number <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <div class="input-group">
              <span class="input-group-text">+91</span>
              <input id="phone" type="text" class="form-control"
                [ngClass]="{'is-invalid': commentForm.get('phone')?.touched && commentForm.get('phone')?.invalid}"
                formControlName="phone" autocomplete="off" inputmode="numeric" maxlength="10" minlength="10"
                placeholder="Enter 10-digit number" (keypress)="allowOnlyNumbers($event)" />
              <div class="invalid-feedback">
                <ng-container *ngIf="commentForm.get('phone')?.hasError('required')">Phone number is
                  required.</ng-container>
                <ng-container *ngIf="commentForm.get('phone')?.hasError('pattern')">Enter a valid 10-digit phone
                  number.</ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Address -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="address" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            Address <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input id="address" type="text" class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('address')?.touched && commentForm.get('address')?.invalid}"
              formControlName="address" autocomplete="off" maxlength="500" />
            <div class="invalid-feedback">Address is required (max 500 chars).</div>
          </div>
        </div>
      </div>

      <!-- Tax Registration Number -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="taxNumber" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            GST Number <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input id="taxNumber" type="text" class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('taxNumber')?.touched && commentForm.get('taxNumber')?.invalid}"
              formControlName="taxNumber" autocomplete="off" maxlength="100" />
            <div class="invalid-feedback">Tax Number is required (max 100 chars).</div>
          </div>
        </div>
      </div>

      <!-- Bank Account Details -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="bankDetails" class="col-sm-3 col-form-label bg-primary text-white py-2 ">
            Bank Account Details <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input id="bankDetails" type="text" class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('bankDetails')?.touched && commentForm.get('bankDetails')?.invalid}"
              formControlName="bankDetails" autocomplete="off" maxlength="500" />
            <div class="invalid-feedback">Bank Details are required (max 500 chars).</div>
          </div>
        </div>
      </div>

      <!-- Submit -->
      <div class="col-12 d-flex justify-content-end">
        <button type="submit" class="btn btn-primary px-4" [disabled]="commentForm.invalid">
          Submit
        </button>
      </div>
    </div>
  </form>

</p-dialog>




<p-dialog header="View Vendor Details" [(visible)]="displayUploadDialog" [modal]="true" [closable]="true"
  [maximizable]="false" [style]="{width: '60vw'}" appendTo="body">
  <div class="p-fluid">
    <div class="p-2 bg-white">
      <table class="w-full text-sm border-collapse border-2 border-gray-600">
        <tbody>
          <!-- Row 1 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Name
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.name || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Proposal Name
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.proposal_name || '-' }}
              </span>
            </td>
          </tr>
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Category
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.category || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Challenge Status
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span *ngIf="['Reject','Duplicate','Accept'].includes(applicantData?.challenge_status)" [ngClass]="{
                  'inline-flex items-center px-3 py-1 rounded-full text-xs font-bold border': true,
                  'border-green-200 bg-green-100 text-green-700': applicantData?.challenge_status === 'Accept',
                  'border-yellow-300 bg-yellow-100 text-yellow-700': applicantData?.challenge_status === 'Duplicate',
                  'border-red-200 bg-red-100 text-red-700': applicantData?.challenge_status === 'Reject'
                }">
                {{ applicantData?.challenge_status | uppercase}}
              </span>
              <span *ngIf="!['Reject','Duplicate','Accept'].includes(applicantData?.challenge_status)"
                class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.challenge_status || '-' }}
              </span>
            </td>
          </tr>



          <!-- Row 3 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Status
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span [ngClass]="getStatusClass(applicantData?.vendor_status)"
                class="inline-flex items-center px-3 py-1 rounded-full text-xs border border-green-200 font-bold bg-green-100 text-green-700">
                {{ applicantData?.vendor_status | uppercase }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Challenge No
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.challenge_number || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 4 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Applying As
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span
                class="inline-flex px-2 py-1 bg-blue-100 text-blue-700 rounded border border-blue-200 mr-2 text-xs font-medium">
                {{ applicantData?.applying_as || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Technology
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.technology || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 5 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Thematic OC
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.themenetic || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Gender
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.gender || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 6 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Phone Number
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.phone_number || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Email
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.email || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 7 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              State(s)
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <ng-container *ngIf="applicantStatesArray?.length; else statesNone">
                <span *ngFor="let st of applicantStatesArray"
                  class="inline-block px-2 py-1 bg-blue-100 text-blue-700 rounded border border-blue-200 mr-2 mb-1 text-xs font-medium">
                  {{ st?.name || st }}
                </span>
              </ng-container>
              <ng-template #statesNone>
                <span class="text-gray-400">-</span>
              </ng-template>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Address
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.address || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 8 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Company Name
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.company_name || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              What You Are
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.what_you || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 9 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Registration No
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.registration_no || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Registration Year
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.registration_year || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 10 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Registered Address
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.registered_address || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Innovation Title
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.innovation_title || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 11 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Title of Innovative Technology
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.title_innovative || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Terms & Conditions
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.term_condition || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 12 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              {{applicantData?.agencie_1}} Recommendations
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.recommendations_1 || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              {{applicantData?.agencie_1}} Comments
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.comments_1 || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 13 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              {{applicantData?.agencie_2}} Recommendations
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.recommendations_2 || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              {{applicantData?.agencie_2}} Comments
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.comments_2 || '-' }}
              </span>
            </td>
          </tr>

          <!-- Row 14 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              {{applicantData?.agencie_3}} Recommendations
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.recommendations_3 || '-' }}
              </span>
            </td>

            <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              {{applicantData?.agencie_3}} Comments
            </td>
            <td class="px-4 py-2 border-2 border-gray-600">
              <span class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.comments_3 || '-' }}
              </span>
            </td>
          </tr>
          <!-- Row 2 -->
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
              <h4> Recommendation (PI)</h4>

            </td>
            <td colspan="3" class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
              <div class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.recommendation_pi || '-' }}
              </div>
            </td>
          </tr>
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
              <h4>Description</h4>

            </td>
            <td colspan="3" class="px-4 py-2 font-semibold   border-2 border-gray-600 ">
              <div class="whitespace-pre-wrap min-w-[100px]">
                {{ applicantData?.description || '-' }}
              </div>
            </td>


          </tr>
          <tr class="border-b">
            <td class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
              <h4>Brief of the proposal & Likely/intended use case</h4>

            </td>
            <td colspan="3" class="px-4 py-2    border-2 border-gray-600 ">
              <div class="whitespace-pre-wrap min-w-[100px]">
                <span [innerHTML]="applicantData?.brief"></span>
              </div>
            </td>


          </tr>

        </tbody>
      </table>
    </div>
    <ng-container *ngIf="!!applicantData?.briefcase?.documents?.length; else noDocuments">
      <div class="flex justify-end items-center mt-3">
        <button class="px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition mb-3" type="button"
          (click)="downloadProposal(applicantData.briefcase)">
          <i class="pi pi-download mr-1"></i>
          Download All as Zip
        </button>
      </div>
      <div class="flex flex-wrap gap-3 my-2">
        <ng-container *ngFor="let doc of applicantData?.briefcase?.documents">
          <div
            class="flex items-center gap-2 p-2 bg-blue-50 rounded-lg shadow-sm border border-blue-100 hover:shadow-md cursor-pointer min-w-[200px] transition-all"
            (mouseenter)="doc._hover = true" (mouseleave)="doc._hover = false">
            <!-- Compact File Icon -->
            <span>
              <ng-container [ngSwitch]="true">
                <i *ngSwitchCase="doc.type_document?.toLowerCase()?.includes('pdf')"
                  class="pi pi-file-pdf text-xl text-red-500"></i>
                <i *ngSwitchCase="doc.type_document?.toLowerCase()?.includes('doc')"
                  class="pi pi-file-word text-xl text-blue-600"></i>
                <i *ngSwitchDefault class="pi pi-paperclip text-xl text-gray-400"></i>
              </ng-container>
            </span>
            <div class="flex-1 min-w-0">
              <div class="truncate font-semibold text-xs text-gray-800 flex items-center">
                {{ doc.name || 'Document' }}
                <span *ngIf="doc.type_document"
                  class="ml-1 bg-gray-100 text-blue-400 px-1 py-0.5 rounded-full text-2xs uppercase tracking-wide">
                  {{ doc.type_document.replace('.', '') }}
                </span>
              </div>
              <div *ngIf="doc.size" class="text-2xs text-gray-400 truncate mt-0.5">
                {{ doc.size | number }} bytes
              </div>
            </div>
            <!-- Actions shown on hover or always on mobile -->
            <div class="flex items-center gap-1" [class.opacity-100]="doc._hover" [class.opacity-70]="!doc._hover">
              <a [href]="baseUrl + doc.url" [attr.download]="doc.name" target="_blank"
                class="p-1 rounded-lg text-blue-600 hover:bg-blue-200 transition" title="View & Download">
                <i class="pi pi-download"></i>
              </a>

            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #noDocuments>
      <div class="p-2 text-gray-400 italic text-center text-xs flex items-center justify-center gap-2">
        <i class="pi pi-info-circle"></i> No documents attached
      </div>
    </ng-template>
  </div>
</p-dialog>


<p-dialog header="Hide/Show Columns" [(visible)]="showSampleDialog" [modal]="true" [closable]="true"
  [dismissableMask]="true" [style]="{width: '750px'}">
  <div class="p-2 bg-white">
    <!-- INSERT_YOUR_CODE -->
    <!-- <label class="font-semibold mb-2 block">Hide/Show Columns:</label> -->
    <div class="grid grid-cols-3  gap-2">
      <ng-container *ngFor="let column of tableColumns">
        <div class="flex items-center border">
          <input type="checkbox" [(ngModel)]="column.visible" (ngModelChange)="syncVisibleColumns()"
            id="{{'column-toggle-' + column.field}}" class="mr-2 p-2 h-10" />
          <label [for]="'column-toggle-' + column.field">{{ column.header }}</label>
        </div>
      </ng-container>
    </div>
  </div>
</p-dialog>

